import { EcommerceProductApi, EcommerceProduct, Variant, VariantEcom } from '@/types/Product';

export class EcommerceProductMapper {
    private static properties: Array<keyof EcommerceProductApi> = ['options', 'variants'];

    static getEcommerceProductFromData(ecommerceProductData: EcommerceProductApi): EcommerceProduct {
        EcommerceProductMapper.checkEcommerceProductData(ecommerceProductData);
        const { options, variants } = ecommerceProductData;

        const ecomProduct: EcommerceProduct = {
            options: options || {},
            variants: variants || []
        };

        return ecomProduct;
    }

    private static checkEcommerceProductData(ecommerceProductData: EcommerceProductApi): void {
        EcommerceProductMapper.properties.forEach((prop) => {
            if (ecommerceProductData[prop] == null) {
                console.error(`Property ${prop} is missing or undefined.`);
            }
        });
    }

    static updateVariantFromEcomData(variant: Variant, variantData: VariantEcom): Variant {
        const { prices } = variantData;
        variant.prices = prices;

        return variant;
    }
}
